import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

const UpgradeModal = ({ isOpen, toggle }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate("/subscription");
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle} className="bg-primary-subtle">
        Upgrade to Access This Feature
      </ModalHeader>
      <ModalBody>
        <div className="text-center mb-4">
          <i className="ri-vip-crown-fill text-warning" style={{ fontSize: "4rem" }}></i>
          <h4 className="mt-3">This is a Premium Feature</h4>
          <p className="text-muted">
            Placing orders is only available for paid subscribers. Upgrade now to access this feature and unlock the full potential of your membership.
          </p>
        </div>

        <div className="mb-3">
          <h5 className="mb-3">Membership Benefits:</h5>
          <ul className="list-unstyled">
            <li className="mb-2">
              <i className="ri-check-line text-success me-2"></i>
              Full time staff of Buyers and Product Analysts
            </li>
            <li className="mb-2">
              <i className="ri-check-line text-success me-2"></i>
              Access to thousands of curated products that are updated daily
            </li>
            <li className="mb-2">
              <i className="ri-check-line text-success me-2"></i>
              No need to set up supplier accounts, we do the heavy lifting!
            </li>
            <li className="mb-2">
              <i className="ri-check-line text-success me-2"></i>
              Integration with Sellercloud ($1200 value) which allows for inventory management and fulfillment across 100's of sales channels
            </li>
            <li className="mb-2">
              <i className="ri-check-line text-success me-2"></i>
              Automated process from product ordering to end customer fulfillment
            </li>
            <li className="mb-2">
              <i className="ri-check-line text-success me-2"></i>
              Weekly HOT list items that are fast selling!
            </li>
          </ul>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
        <Button color="primary" onClick={handleUpgrade}>
          <i className="ri-arrow-right-line me-1"></i>
          Upgrade to a Paid Plan
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpgradeModal;
